module.exports = __webpack_public_path__ + "img/poster-master-3.3f38bcdb.jpg";